import posthog from 'posthog-js';

const actions = {
    trackEvent(_, { event, properties }) {
        posthog.capture(event, properties);
    }
};

export default {
    namespaced: true,
    actions
}; 